<span class="chip margin-right-small hover">All</span>
<span class="chip margin-right-small hover">2018</span>
<span class="chip margin-right-small hover">2019</span>
<span class="chip hover">2020</span>

<div class="card chart-wrapper margin-top margin-bottom">
  <canvas baseChart
          [data]="catalogChart.data"
          [options]="catalogChart.options"
          [type]="catalogChart.type"
          >
          <!-- [colors]="catalogChart.colors" -->
          <!-- [chartType]="catalogChart.type" -->
  </canvas>

</div>

<h4>Invoices List</h4>


<div class="card margin-top">
  <table>
    <tr>
      <th>Invoice Number</th>
      <th>Order #</th>
      <th>Date</th>
    </tr>
    <tr>
      <td>Alfreds Futterkiste</td>
      <td>Maria Anders</td>
      <td>Germany</td>
    </tr>
    <tr>
      <td>Centro comercial Moctezuma</td>
      <td>Francisco Chang</td>
      <td>Mexico</td>
    </tr>
    <tr>
      <td>Ernst Handel</td>
      <td>Roland Mendel</td>
      <td>Austria</td>
    </tr>
    <tr>
      <td>Island Trading</td>
      <td>Helen Bennett</td>
      <td>UK</td>
    </tr>
    <tr>
      <td>Laughing Bacchus Winecellars</td>
      <td>Yoshi Tannamuri</td>
      <td>Canada</td>
    </tr>
    <tr>
      <td>Magazzini Alimentari Riuniti</td>
      <td>Giovanni Rovelli</td>
      <td>Italy</td>
    </tr>
  </table>
</div>
